import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import MailIcon from '@mui/icons-material/Mail';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import Paper from '@mui/material/Paper';

import { User, UserGroup } from '../states/settingState';

type Props = {
  open: boolean;
  user: User;
  userGroups: UserGroup[];
  role: string;
  handleUpdateUserObject: (user: User) => void;
  handleClose: () => void;
  handleOk: () => void;
};

export const UserUpdateDialog: React.FC<Props> = (props) => {

  const [subDialog, setSubDialog] = React.useState(false);
  const openSubDialog = Boolean(subDialog);
  const closeSubDialog = () => setSubDialog(false);
  const [subMessage, setSubMessage] = React.useState<string>('');

  const handleOrignOk = () => {
    if (props.user.name) {
      props.handleOk();
    } else {
      setSubMessage('ユーザ名は必須です。');
      setSubDialog(true);
    }
  }

  const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    const newValue = value.replace(/[\s]/g, '');
    const newnewValue = newValue ? newValue : '';
    const news: User = JSON.parse(JSON.stringify(props.user));
    news.name = newnewValue;
    props.handleUpdateUserObject(news);
  };
  const handleChangeRole = (event) => {
    const news: User = JSON.parse(JSON.stringify(props.user));
    news.role = event.target.value;
    props.handleUpdateUserObject(news);
  };
  const handleChangeUserGroup = (event) => {
    const news: User = JSON.parse(JSON.stringify(props.user));
    news.userGroupId = event.target.value;
    props.handleUpdateUserObject(news);
  };
  const handleChangeEnabled = (event) => {
    const news: User = JSON.parse(JSON.stringify(props.user));
    news.enabled = event.target.checked;
    props.handleUpdateUserObject(news);
  };

  const createUserGroups = () => {
    return props.userGroups.map((g, i) => {
      return (<MenuItem key={'' + i} value={g.userGroupId} >{g.groupName}</MenuItem>);
    });
  };

  const getRoles = () => {
    const roles: React.JSX.Element[] = [];
    if (props.role === 'Manager') {
      roles.push((<MenuItem key={'0'} value={'Manager'} >{'管理者'}</MenuItem>));
    }
    roles.push((<MenuItem key={'1'} value={'Approver'} >{'承認者'}</MenuItem>));
    roles.push((<MenuItem key={'2'} value={'Editor'} >{'編集者'}</MenuItem>));
    roles.push((<MenuItem key={'3'} value={'Viewer'} >{'閲覧者'}</MenuItem>));

    return roles;
  };

  const createContents = () => {
    return (
      <>
        <MailIcon color='primary' sx={{
          position: 'relative',
          top: 5,
          left: 5,
          marginRight: 2,
        }} />
        <Typography variant="body1" component="span">{props.user.eMail}</Typography>
        <br />
        <TextField
          id={'name'}
          label={'ユーザー名'}
          value={props.user.name}
          sx={{
            width: 640,
          }}
          onChange={handleChangeName}
          margin="normal"
          variant="outlined"
        />
        <br />
        <FormControl sx={{ m: 1, minWidth: 200 }}>
          <InputLabel id="type-select-readonly-label">ユーザー権限</InputLabel>
          <Select
            labelId="type-select-helper-label"
            id="type-select-helper"
            label="ユーザー権限"
            value={props.user.role}
            onChange={handleChangeRole}
          >
            {getRoles()}
          </Select>
        </FormControl>
        <br />
        <FormControl sx={{ m: 1, minWidth: 200 }}>
          <InputLabel id="type-select-readonly-label">所属グループ</InputLabel>
          <Select
            labelId="type-select-helper-label"
            id="type-select-helper"
            label="所属グループ"
            value={props.user.userGroupId}
            onChange={handleChangeUserGroup}
          >
            {createUserGroups()}
          </Select>
        </FormControl>
        <br />
        <FormControlLabel
          control={
            <Checkbox
              checked={props.user.enabled}
              onChange={handleChangeEnabled}
              name="isUnlimited"
              color="primary"
            />
          }
          label={props.user.enabled ? '有効' : '無効'}
        />
      </>
    );
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"ユーザー情報の更新"}</DialogTitle>
      <DialogContent sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
          margin: (theme) => theme.spacing(1),
        },
      }}>
        <Paper sx={{
          minWidth: 240,
          margin: (theme) => theme.spacing(1),
          padding: (theme) => theme.spacing(3),
          backgroundColor: (theme) => theme.palette.primary[50],
        }} elevation={3}>
          {createContents()}
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOrignOk} color="primary">
          OK
        </Button>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
      <Dialog
        open={openSubDialog}
        keepMounted
        onClose={closeSubDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">エラー</DialogTitle>
        <DialogContent>
          <Typography>{subMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSubDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};    